import { splitProfileListConstants } from "./splitProfileList.constants";

export const splitProfileListActions = {
	setPaging,
	setSorting,
};

function setSorting({ sortBy: [{ desc, id }] }) {
	return {
		type: splitProfileListConstants.SET_SORTING,
		isDescending: desc,
		sortBy: id,
	};
}

function setPaging({ pageIndex, pageSize }) {
	return {
		type: splitProfileListConstants.SET_PAGING,
		pageIndex,
		pageSize,
	};
}